export default "__VITE_ASSET__BWq2$12G__"